import Vue from 'vue'
import './plugins/axios'
import $ from 'jquery'
import App from './App.vue'
import router from './router'
import './assets/css/global.css'
import {
  server
} from './http/http-service'
import tool from './assets/js/tool'
import {
  Message,
  Button,
  Form,
  FormItem,
  Input,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup
} from 'element-ui'

Vue.use(Button)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)

// 定义全局变量
Vue.prototype.$server = server // 封装axios
Vue.prototype.tool = tool // 封装cookie
Vue.prototype.$message = Message

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
